import React from 'react'

function SettingsMember() {
  return (
    <div>SettingsMember</div>
  )
}

export default SettingsMember